import { defineMessages } from 'react-intl';

const messages = defineMessages({
  companyName: {
    id: 'editForm.companyName',
    defaultMessage: 'Company Name',
    description: 'Your Company Name to Register',
  },
  companyNameRequired: {
    id: 'editForm.companyNameRequired',
    defaultMessage: 'Company Name is required',
    description: 'Company Name Required',
  },
  address1: {
    id: 'editForm.address1',
    defaultMessage: 'Address1',
    description: 'Address1',
  },
  address1Required: {
    id: 'editForm.address1Required',
    defaultMessage: 'Address1 is required',
    description: 'Address1 Required',
  },
  address2: {
    id: 'editForm.address2',
    defaultMessage: 'Address2',
    description: 'Your Address2 to Register',
  },
  address2Required: {
    id: 'editForm.address2Required',
    defaultMessage: 'Address2 is required',
    description: 'Address2 Required',
  },
  city: {
    id: 'editForm.city',
    defaultMessage: 'City',
    description: 'Your City to Register',
  },
  cityRequired: {
    id: 'editForm.cityRequired',
    defaultMessage: 'City is required',
    description: 'City Required',
  },
  zip: {
    id: 'editForm.zip',
    defaultMessage: 'Zip code',
    description: 'Your Zip code to Register',
  },
  zipRequired: {
    id: 'editForm.zipRequired',
    defaultMessage: 'Zip code is required',
    description: 'Zip code Required',
  },
  firstName: {
    id: 'editForm.firstName',
    defaultMessage: 'First name',
    description: 'Your First name to Register',
  },
  firstNameRequired: {
    id: 'editForm.firstNameRequired',
    defaultMessage: 'First name is required',
    description: 'First name Required',
  },
  lastName: {
    id: 'editForm.lastName',
    defaultMessage: 'Last name',
    description: 'Your Last name to Register',
  },
  lastNameRequired: {
    id: 'editForm.lastNameRequired',
    defaultMessage: 'Last name is Required',
    description: 'Last name Required',
  },
  email: {
    id: 'editForm.email',
    defaultMessage: 'Email Address',
    description: 'Your Email Address to Login',
  },
  emailRequired: {
    id: 'editForm.emailRequired',
    defaultMessage: 'Email is required',
    description: 'Email is required',
  },
  emailInvalid: {
    id: 'editForm.emailInValid',
    defaultMessage: 'Invalid Email Address',
    description: 'Invalid Email Address',
  },
  emailAlreadyExists: {
    id: 'editForm.emailAlreadyExists',
    defaultMessage: 'That email address is already in use. Please choose different one!',
    description: 'Email Address is already exist',
  },
  iAm: {
    id: 'editForm.iam',
    defaultMessage: 'I am',
    description: 'Gender Label',
  },
  gender: {
    id: 'editForm.gender',
    defaultMessage: 'Gender',
    description: 'Gender Field',
  },
  genderMale: {
    id: 'editForm.genderMale',
    defaultMessage: 'Male',
    description: 'Gender Male',
  },
  genderFemale: {
    id: 'editForm.genderFemale',
    defaultMessage: 'Female',
    description: 'Gender Female',
  },
  genderOther: {
    id: 'editForm.genderOther',
    defaultMessage: 'Other',
    description: 'Gender Other',
  },
  genderRequired: {
    id: 'editForm.genderRequired',
    defaultMessage: 'Gender is Required',
    description: 'Gender is Required',
  },
  preferredLanguage: {
    id: 'editForm.preferredLanguage',
    defaultMessage: 'Preferred Language',
    description: 'Preferred Language',
  },
  preferredLanguageRequired: {
    id: 'editForm.preferredLanguageRequired',
    defaultMessage: 'Preferred Language is Required',
    description: 'Preferred Language is Required',
  },
  preferredCurrency: {
    id: 'editForm.preferredCurrency',
    defaultMessage: 'Preferred Currency',
    description: 'Preferred Currency',
  },
  preferredCurrencyRequired: {
    id: 'editForm.preferredCurrencyRequired',
    defaultMessage: 'Preferred Currency is Required',
    description: 'Preferred Currency is Required',
  },
  phoneNumber: {
    id: 'editForm.phoneNumber',
    defaultMessage: 'Phone Number',
    description: 'Phone Number',
  },
  phoneNumberRequired: {
    id: 'editForm.phoneNumberRequired',
    defaultMessage: 'Phone Number is Required',
    description: 'Phone Number is Required',
  },
  phoneNumberInvalid: {
    id: 'editForm.phoneNumberInvalid',
    defaultMessage: 'Invalid Phone Number',
    description: 'Phone Number is Invalid',
  },
  location: {
    id: 'editForm.location',
    defaultMessage: 'Where You Live',
    description: 'location',
  },
  locationRequired: {
    id: 'editForm.locationRequired',
    defaultMessage: 'Location is required',
    description: 'Location is required',
  },
  info: {
    id: 'editForm.info',
    defaultMessage: 'Describe Yourself',
    description: 'Describe Yourself',
  },
  infoRequired: {
    id: 'editForm.infoRequired',
    defaultMessage: 'Describe Yourself is Required',
    description: 'Describe Yourself is Required',
  },
  somethingWentWrong: {
    id: 'editForm.somethingWentWrong',
    defaultMessage: 'Sorry, something went wrong. Please try again',
    description: 'Wrong went wrong',
  },
  birthDay: {
    id: 'editForm.birthDay',
    defaultMessage: 'Birthday',
    description: 'Your Birthday to Register',
  },
  birthDayRequired: {
    id: 'editForm.birthDayRequired',
    defaultMessage: 'Birthday is required',
    description: 'Birthday Required',
  },
  save: {
    id: 'editForm.save',
    defaultMessage: 'Save',
    description: 'Save Button',
  },

});

export default messages;
